import { ajaxMarkup } from '../../../helpers/ajax';

export const getUrl = () =>
    window.location.href.split('?')[0].split('/').slice(0, 8).concat('odds-table').join('/');

const fetchOddsTable = () => new Promise((resolve) => {
    ajaxMarkup(getUrl()).then((html) => {
        resolve(html.split('<!-- cut -->')[1]);
    });
});

export default fetchOddsTable;



// WEBPACK FOOTER //
// ./lib/js/modules/odds/helpers/fetchOddsTable.js